import { render, staticRenderFns } from "./publishVideo.vue?vue&type=template&id=9652de1a&scoped=true"
import script from "./publishVideo.vue?vue&type=script&lang=js"
export * from "./publishVideo.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/publish.css?vue&type=style&index=0&id=9652de1a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9652de1a",
  null
  
)

export default component.exports